import React from 'react';
import { IconButton as MuiIconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

const IconButton = ({
  type,
  style,
  children,
  onClick,
}: {
  type: 'add' | 'edit' | 'delete' | 'close' | 'save' | 'custom';
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  return (
    <MuiIconButton
      style={{
        background: type !== 'delete' ? '#f0f0f0' : '#990000',
        width: 47,
        height: 47,
        padding: 10,
        ...style,
      }}
      onClick={onClick}
    >
      {type === 'edit' ? (
        <EditIcon />
      ) : type === 'delete' ? (
        <DeleteOutlineIcon style={{ color: '#fff' }} />
      ) : type === 'close' ? (
        <CloseIcon />
      ) : type === 'save' ? (
        <CheckIcon />
      ) : type === 'custom' ? (
        children
      ) : (
        <AddIcon />
      )}
    </MuiIconButton>
  );
};

export default IconButton;
